import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Button } from "@mui/material"
import { AuthBox, HorizontalLayout, MainContainer, VerticalLayout } from "../../common/common-layout"
import BTBox from "../../common/components/BTBox"
import theme from '../../common/theme';
import loginCi from "../../assets/icons/login_ci.svg"
import { TitleNormal } from "../../common/common-text"
import BaseLayout from "../BaseLayout"

const FindUsernameResult = () => {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const location = useLocation();
    const state = location.state as boolean;

    const handleMoveToLogin = () => {
        navigate("/login");
    };

    return (
        <BaseLayout>
            <MainContainer backgroundColor='#14B446'>
                <AuthBox style={{ width: '516px' }}>
                    <VerticalLayout>
                        <form style={{ width: 516 }}>
                            <BTBox height="20px" />
                            <HorizontalLayout style={{ justifyContent: 'center', width: '100%' }}>
                                <img src={loginCi} />
                            </HorizontalLayout>
                            <BTBox height='50px' />
                            {
                                state ?
                                    <TitleNormal
                                        fontSize={24}
                                        style={{ textAlign: 'center', lineHeight: 1.75 }}
                                    >
                                        아이디 정보를 해당 이메일로 전송하였습니다.<br />
                                        이메일을 확인해주세요.
                                    </TitleNormal>
                                    :
                                    <TitleNormal
                                        fontSize={24}
                                        style={{ textAlign: 'center', lineHeight: 1.75 }}
                                    >
                                        해당 이메일로 생성된 아이디가 없습니다.<br />
                                        가입 이메일 정보를 다시 확인해주세요.
                                    </TitleNormal>
                            }

                            {error && <p style={{ color: "red" }}>{error}</p>}

                            <BTBox height='30px' />
                            <Button
                                onClick={handleMoveToLogin}
                                style={{
                                    width: '100%',
                                    height: '59px',
                                    fontSize: '20px',
                                    fontWeight: 700,
                                    backgroundColor: theme.colors.bbTech, // 원하는 색상
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    outline: 'none',
                                }}
                            >
                                로그인으로 돌아가기
                            </Button>
                            <BTBox height='20px' />
                        </form>
                    </VerticalLayout>
                </AuthBox>

            </MainContainer>
        </BaseLayout>
    );
};

export default FindUsernameResult;